export default "__VITE_ASSET__BlezzpZV__"